import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class ContactUS extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
    }
    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-9">
                                    <h2 className="text-white text-uppercase mt-4">Contact US</h2>
                                </div>
                            </div>
                        </section>
                        <section className="contact pb-6">
                            <div className="container">
                                <div className="contact-inner text-center text-md-start">
                                    <div className="row g-md-5 gy-5 align-items-center">
                                        <div className="col-lg-6  mt-2">
                                            <div className="contact-event-info p-4 text-dark h-100 rounded border">
                                                <div className="event-venue contact-head pb-3">
                                                    <h6 className=" pb-1">India ITME Society</h6>
                                                    <p className="m-0">
                                                        1210/1211/1212 Dalamal Tower, ‘A’ Wing, 12th Floor, Plot
                                                        No.211, Nariman Point, Mumbai – 400 021, INDIA
                                                    </p>
                                                </div>
                                                <div className="address contact-head pb-3">
                                                    <h6 className=" pb-1">Landline Numbers :</h6>
                                                    <p className="m-0">+91-22-4972 4603 / 2202 0032 / 2285 1579</p>
                                                </div>
                                                <div className="ticket-info contact-head pb-3">
                                                    <h6 className=" pb-1">WhatsApp Assistance Only :</h6>
                                                    <p className="m-0">
                                                        {" "}
                                                        <a
                                                            href="https://api.whatsapp.com/send/?phone=918010823774&text=I+need+assistance+for&type=phone_number&app_absent=0"
                                                            className="text-primary"
                                                        >
                                                            +91 8010 823 774 (For Administration Queries)
                                                        </a>
                                                    </p>
                                                </div>
                                                <div className="ticket-info contact-head pb-3">
                                                    <p className="m-0">
                                                        {" "}
                                                        <b>Email :</b>
                                                        <a href="mailto:itme@india-itme.com" className="text-primary">
                                                            {" "}
                                                            itme@india-itme.com
                                                        </a>
                                                    </p>
                                                    <p className="m-0">
                                                        {" "}
                                                        <b>Skype :</b> indiaitme2012
                                                    </p>
                                                    <p className="m-0">
                                                        <b>Website :</b>{" "}
                                                        <a
                                                            href="https://www.india-itme.com/"
                                                            className="text-primary"
                                                        >
                                                            {" "}
                                                            www.india-itme.com
                                                        </a>
                                                    </p>
                                                </div>
                                                <div className="ticket-info contact-head pb-3">
                                                    <p className="m-0">
                                                        {" "}
                                                        <b>Working days :</b>Monday - Friday
                                                    </p>
                                                    <p className="m-0">
                                                        {" "}
                                                        <b>Working Hrs</b>10:00 am to 06:00 pm, IST (GMT +05:30)
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <table border={1} cellPadding={10} cellSpacing={0}>
                                                <thead>
                                                    <tr>
                                                        <th>Queries</th>
                                                        <th>Ask for</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>General Queries</td>
                                                        <td>
                                                            Mr. Bhupendra Thakur –{" "}
                                                            <a href="tel:+917021089987" className="text-primary">
                                                                91 7021089987
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="map-direction mt-5">
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.1564729973984!2d72.82185397373209!3d18.92446695671512!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1ebd9df6e27%3A0xea7edaf958839b28!2sDalamal%20Towers!5e0!3m2!1sen!2sin!4v1728480845217!5m2!1sen!2sin"
                                            width="100%"
                                            height={350}
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            className="rounded-4"
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(ContactUS)
);
